// @ts-nocheck
import TetherPortal from './TetherPortal'
import './TetherPortal.scss'
export default TetherPortal
